import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";

// Если во время обновления сервера пользователь кликает по сайту, 
// мы ловим ошибку отсутствия файлов и принудительно перезагружаем страницу, 
// чтобы показать анимацию загрузки.
window.addEventListener('error', (e) => {
  if (e.message && /Loading chunk/i.test(e.message)) {
    window.location.reload();
  }
});
// ==========================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();